import { service } from '@/request/server'

// 访客列表
export const visitorList = (params) => (
  service({
    url: '/Visitor/visitorList',
    method: 'GET',
    params
  })
)

// 删除访客记录
export const delVisitorLog = (params) => (
  service({
    url: '/Visitor/delVisitorLog',
    method: 'GET',
    params
  })
)
